// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"773":"e3646bae","845":"b5f689a1"}[chunkId] + ".chunk.js";
};